import * as React from "react";
import { Component } from "react";
import { Button } from "reactstrap";
import arr from "../util/ArrayDecorator";

interface TagsProps {
  tags: Array<string>;
  availableTags: Array<string>;
  onTagsChanged(tags: Array<string>): void;
}
export default class Tags extends Component<TagsProps> {
  render(): React.ReactNode {
    const availableTags = this.props.availableTags;

    return availableTags.map((tag, idx) => {
      const className =
        "tag-button " +
        (this.containsTag(this.props.tags, tag) ? "active " : "") +
        (idx !== availableTags.length - 1 ? "mr-1" : "");

      return (
        <Button outline color="info" size="sm" key={tag} className={className} onClick={() => this.triggerTag(tag)}>
          {tag}
        </Button>
      );
    });
  }

  private containsTag(tags: Array<string>, tag: string): boolean {
    return arr(tags).containsElement(tag);
  }

  private triggerTag(tag: string): void {
    const tags = this.props.tags;

    if (this.containsTag(tags, tag)) {
      arr(tags).remove((t) => t === tag);
    } else {
      tags.push(tag);
    }

    this.props.onTagsChanged(tags);
  }
}
